/// <amd-module name="Wit/UI/Components/IdentityView/index" />
export { IIdentityViewProps } from "./IdentityView.Props";
export * from "./IdentityView";
